module.exports = __webpack_public_path__ + "img/nouvelleStructure.bc017644.png";